<template>
    <div class="main-cn" >
        <div class="main-hd" >
            <h4>新增线索</h4>
        </div>
        <div class="main-bd mg20" >
            <el-row>
                <el-col>
                    <clue-form :model="model" @submit="submitForm" ></clue-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>

import ClueService from "~/services/SaleClues"
import clueForm from "~/views/clue/form.vue";
export default {
    data() {
        return {
            model: {
                products: [],
                productsId: []
            }
        }
    },
    components: {
        clueForm
    },
    methods: {
        submitForm(params) {
            ClueService.addSaleClue(params).then( res => {
                if(res.code == 0) {
                    this.$message({
                        message:'创建成功',
                        type:'success'
                    });
                    this.$router.push({ path: this.$route.query['referer'] ||  "/sales-leads/index" });
                } else {
                    return;
                }
            });
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/views/clue/create.vue